import React from 'react';
import { School, CalendarClock } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export const MyClassroomHeader = ({ access, childCount, checkedIn }) => {
  if (!access) return null;
  const rooms = access.classrooms;
  const assigned = rooms ? rooms.filter((r) => !access.temp_today?.includes(r)) : null;
  return (
    <div className="card-clay p-5 flex flex-wrap items-center gap-3" data-testid="my-classroom-header">
      <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center"><School className="w-6 h-6" /></div>
      <div className="min-w-0">
        <p className="font-heading font-bold text-lg" data-testid="my-classroom-name">
          {assigned ? `My Classroom: ${assigned.join(', ')}` : 'All Classrooms'}
        </p>
        <p className="text-sm text-muted-foreground" data-testid="my-classroom-summary">{childCount} children · {checkedIn} checked in</p>
      </div>
      {(access.temp_today || []).map((r) => (
        <Badge key={r} className="bg-amber-100 text-amber-800 hover:bg-amber-100 gap-1" data-testid={`covering-badge-${r.replace(/\s+/g, '-').toLowerCase()}`}>
          <CalendarClock className="w-3 h-3" /> Covering today: {r}
        </Badge>
      ))}
    </div>
  );
};
